import { DEFAULT_PROJECTS_TITLE, PRO_PROJECTS_TITLE } from '../../../../../constants/project/general';
import { resolveHomepageSectionsImage } from '../../../../../helpers/construct/page-content.helper';
import { useCustomer } from '../../../../../hooks/apollo/customer/customer.hooks';
import { type ContentComponent, type ProjectsContent } from '../../../../../types/construct.types';
import { Projects } from '../../../../home-components/projects/projects.component';

export const ProjectsHandler: ContentComponent<ProjectsContent> = ({
	content: {
		fields: { image }
	}
}) => {
	const { isPro } = useCustomer();
	const title = isPro ? PRO_PROJECTS_TITLE : DEFAULT_PROJECTS_TITLE;
	return <Projects image={resolveHomepageSectionsImage(image)} title={title} automationHook="project-tool-room-list" />;
};
